/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StateVariableAction {
    ENABLE = 'enable',
    DISABLE = 'disable',
    TOGGLE = 'toggle'
}


export function instanceOfStateVariableAction(value: any): boolean {
    for (const key in StateVariableAction) {
        if (Object.prototype.hasOwnProperty.call(StateVariableAction, key)) {
            if (StateVariableAction[key as keyof typeof StateVariableAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StateVariableActionFromJSON(json: any): StateVariableAction {
    return StateVariableActionFromJSONTyped(json, false);
}

export function StateVariableActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateVariableAction {
    return json as StateVariableAction;
}

export function StateVariableActionToJSON(value?: StateVariableAction | null): any {
    return value as any;
}

export function StateVariableActionToJSONTyped(value: any, ignoreDiscriminator: boolean): StateVariableAction {
    return value as StateVariableAction;
}

